// import React, { useState, useEffect, KeyboardEvent } from "react";
// import "./BOQAddDetails.css";
// import axios from "axios";
// import API_URL from "../../../src/Config";
// import Tooltip from "@mui/material/Tooltip";
// import { IoMdArrowBack } from "react-icons/io";
// import { useNavigate, useParams } from "react-router-dom";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";

// function BOQAddQtyForWeek({ isSidebarExpanded }) {
//   const [boqDetail, setBoqDetail] = useState([]);
//   const [responseData, setResponseData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [saveStatus, setSaveStatus] = useState({ message: "", type: "" });
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [editedValues, setEditedValues] = useState({});
//   const [isSaving, setIsSaving] = useState(false);
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [boqData, setBoqData] = useState([]); // Store API data
//   const [snackbarMessage, setSnackbarMessage] = useState("");

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const showSnackbar = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarOpen(true);
//   };

//   const handleCancelClick = () => {
//     navigate("/amc-projects");
//   };

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       // Fetch BOQ details
//       const boqResponse = await axios.get(`${API_URL}/api/get_amc_boqs`, {
//         headers: { Authorization: authKey },
//         params: { project_id: id },
//       });

//       setBoqDetail(boqResponse.data.BOQs);

//       // Fetch calculated planned quantity data
//       const calcResponse = await axios.post(
//         `${API_URL}/api/calculate-project-planned-qty`,
//         { project_id: id },
//         {
//           headers: {
//             Authorization: authKey,
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       console.log("calcResponse.data", calcResponse?.data);
//       setResponseData(calcResponse?.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setError(error.message);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchBOQQuantity = async () => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       // Fetch BOQ quantities using the boq_id in the URL
//       const boqQtyResponse = await axios.get(
//         `${API_URL}/api/get_amc_boqs_with_quantities/${id}`,
//         {
//           headers: { Authorization: authKey },
//         },
//       );

//       // Handle the response (e.g., update state with fetched data)
//       console.log(boqQtyResponse.data.BOQs); // Use response data here
//       setBoqData(boqQtyResponse.data.BOQs || []);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setError(error.message);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBOQQuantity();
//   }, []);

//   const handleBack = () => {
//     navigate("/amc-projects");
//   };

//   const getMonthsFromPlannedDistribution = () => {
//     const monthsWithWeeks = [];

//     const boqs = responseData?.boqs || [];

//     boqs.forEach((boq) => {
//       const periods = boq?.periods || [];

//       periods.forEach((p) => {
//         const month = p.month_year;
//         const week = p.label;

//         if (!month || !week) return;

//         let monthEntry = monthsWithWeeks.find((m) => m.month === month);

//         if (!monthEntry) {
//           monthEntry = { month, weeks: [] };
//           monthsWithWeeks.push(monthEntry);
//         }

//         if (!monthEntry.weeks.includes(week)) {
//           monthEntry.weeks.push(week);
//         }
//       });
//     });

//     monthsWithWeeks.forEach((m) => {
//       m.weeks.sort((a, b) => {
//         const aNum = parseInt(a.replace(/\D/g, ""), 10);
//         const bNum = parseInt(b.replace(/\D/g, ""), 10);
//         return aNum - bNum;
//       });
//     });

//     monthsWithWeeks.sort(
//       (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month),
//     );

//     console.log("monthsWithWeeks", monthsWithWeeks)

//     return monthsWithWeeks;
//   };

//   const monthOrder = [
//     "Jan 2025",
//     "Feb 2025",
//     "Mar 2025",
//     "Apr 2025",
//     "May 2025",
//     "Jun 2025",
//     "Jul 2025",
//     "Aug 2025",
//     "Sep 2025",
//     "Oct 2025",
//     "Nov 2025",
//     "Dec 2025",
//   ];

//   const handleInputChange = (month, week, value, boq_id) => {
//     console.log(
//       `Input Change: boq_id=${boq_id}, month=${month}, week=${week}, value=${value}`,
//     );

//     setEditedValues((prevState) => ({
//       ...prevState,
//       [boq_id]: {
//         ...prevState[boq_id],
//         [month]: {
//           ...prevState[boq_id]?.[month],
//           [week]: value,
//         },
//       },
//     }));
//   };

//   const getPlannedDotColor = (actual, planned) => {
//     if (!actual) return "yellow-dot"; // No value entered
//     if (parseFloat(actual) > parseFloat(planned)) return "green-dot"; // Actual > Planned
//     if (parseFloat(actual) < parseFloat(planned)) return "red-dot"; // Actual < Planned
//     return "blue-dot"; // Actual = Planned
//   };

//   const handleKeyPress = async (event, month, week, boq_id) => {
//     if (event.key === "Enter") {
//       try {
//         const newQty = editedValues[boq_id]?.[month]?.[week];
//         if (newQty) {
//           const authKey = localStorage.getItem("authKey");

//           // Convert "week_3" to 3
//           const weekNum = parseInt(week.replace(/\D/g, ""), 10);

//           // Find the matching BOQ item
//           const boqItem = boqData.find((boq) => boq.id === boq_id);

//           // Find the corresponding boq_qty_id from the quantities array
//           const boqQtyItem = boqItem?.quantities?.[month]?.find(
//             (q) => q.week === weekNum,
//           );

//           const boq_qty_id = boqQtyItem?.id || null; // Get the ID or send null if not found

//           // Get planned quantity
//           const plannedQty =
//             responseData?.boqs
//               ?.find((b) => b.boq_id === boq_id)
//               ?.periods?.find((p) => p.month_year === month && p.label === week)
//               ?.planned ?? "";

//           // Construct payload
//           const payload = {
//             boq_id: boq_id,
//             boq_qty_id: boq_qty_id, // Include boq_qty_id in payload
//             month_year: month,
//             week_num: weekNum,
//             qty: newQty,
//             planned_qty: plannedQty, // Send the planned quantity
//           };

//           // Send the payload to the backend API
//           const response = await axios.post(
//             `${API_URL}/api/add_boq_quantity`,
//             payload,
//             {
//               headers: {
//                 Authorization: authKey,
//                 "Content-Type": "application/json",
//               },
//             },
//           );

//           // Optionally, update the response data or show a success message
//           console.log(response.data);
//           if (response.status === 200) {
//             const message = boq_qty_id
//               ? "Quantity updated successfully"
//               : "Quantity added successfully";

//             showSnackbar(message, "success");

//             // optional redirect if needed
//             // setTimeout(() => {
//             //   navigate("/amc-projects");
//             // }, 3000);
//           }

//           await fetchBOQQuantity(); // Refresh data after successful update
//         }
//       } catch (error) {
//         console.error("Error adding BOQ quantity:", error.message);
//         showSnackbar("Failed to save quantity.", "error");
//       }
//     }
//   };

//   function formatNumber(number) {
//     const parts = number.toString().split(".");
//     const integerPart = parts[0];
//     const decimalPart = parts.length > 1 ? "." + parts[1] : "";

//     let formattedIntegerPart = "";
//     let lakhFlag = false;
//     let croreFlag = false;
//     let croreLakhFlag = false;

//     for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
//       if (count === 3 && !lakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         lakhFlag = true;
//       }

//       if (count === 2 && lakhFlag && !croreFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreFlag = true;
//       }

//       if (count === 2 && croreFlag && !croreLakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreLakhFlag = true;
//       }

//       formattedIntegerPart = integerPart[i] + formattedIntegerPart;
//     }

//     return formattedIntegerPart + decimalPart;
//   }

//   const monthsFromPlannedDistribution = getMonthsFromPlannedDistribution();

//   return (
//     <>
//       <div
//         className={`data-list-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="data-edit-form-content">
//           <div className="data-edit-form-header">
//             <div className="data-edit-form-header-content">
//               <div className="data-edit-form-heading-content-left-side">
//                 <Tooltip title="Back" arrow>
//                   <IoMdArrowBack
//                     className="back-company"
//                     onClick={handleBack}
//                   />
//                 </Tooltip>
//                 Add BOQ qty
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="header-separator"></div>

//         <div className="legend-container">
//           <div className="legend-item">
//             <span className="legend-color actual-more"></span>
//             <span>Actual &gt; Planned</span>
//           </div>
//           <div className="legend-item">
//             <span className="legend-color actual-less"></span>
//             <span>Actual &lt; Planned</span>
//           </div>
//           <div className="legend-item">
//             <span className="legend-color actual-equal"></span>
//             <span>Actual = Planned</span>
//           </div>
//           <div className="legend-item">
//             <span className="legend-color no-value"></span>
//             <span>No value entered</span>
//           </div>
//         </div>
//         <div className="data-list-body">
//           <div className="data-list-scroll-body-boq">
//             <div className="data-list-table-boq">
//               {loading ? (
//                 <div className="loader-container">
//                   <div className="loader"></div>
//                   <div>Loading...</div>
//                 </div>
//               ) : boqDetail.length > 0 ? (
//                 <table className="excel-table">
//                   <thead>
//                     <tr>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th1"
//                       >
//                         Service Code
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th2"
//                       >
//                         Description
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th3"
//                       >
//                         UOM
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th4"
//                       >
//                         Quantity
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th5"
//                       >
//                         Unit Rate
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th6"
//                       >
//                         Total Amount Including GSTdccd
//                       </th>

//                       {monthsFromPlannedDistribution.map(
//                         (monthWithWeeks, index) => (
//                           <th colSpan={monthWithWeeks.weeks.length} key={index}>
//                             {monthWithWeeks.month}
//                           </th>
//                         ),
//                       )}
//                     </tr>
//                     <tr>
//                       {monthsFromPlannedDistribution.map(
//                         (monthWithWeeks, monthIndex) => {
//                           return monthWithWeeks.weeks.map((week, weekIndex) => (
//                             <th key={`${monthIndex}-${weekIndex}`}>{week}</th>
//                           ));
//                         },
//                       )}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {boqDetail.map((row, index) => {
//                       // Find matching BOQ item from boqData
//                       const matchingBoq =
//                         boqData.find((boq) => boq.id === row.id) || {};

//                       return (
//                         <tr key={index}>
//                           {/* First API: BOQ Details */}
//                           <td className="sticky-col boq-th1">
//                             {row.service_code}
//                           </td>
//                           <td className="sticky-col boq-th2">
//                             {row.description}
//                           </td>
//                           <td className="sticky-col boq-th3">{row.uom}</td>
//                           <td className="sticky-col boq-th4">{row.qty}</td>
//                           <td className="sticky-col boq-th5">
//                             ₹ {formatNumber(row.unit_rate)}
//                           </td>
//                           <td className="sticky-col boq-th6">
//                             ₹ {formatNumber(row.total_amount_with_gst)}
//                           </td>

//                           {monthsFromPlannedDistribution.map(
//                             (monthWithWeeks) => {
//                               return monthWithWeeks.weeks.map((week) => {
//                                 // Find the matching BOQ item
//                                 const boqItem = boqData.find(
//                                   (boq) => boq.id === row.id,
//                                 );

//                                 // Extract planned quantity from responseData
//                                 const plannedQty =
//                                   responseData?.boqs
//                                     ?.find((b) => b.boq_id === row.id)
//                                     ?.periods?.find(
//                                       (p) =>
//                                         p.month_year === monthWithWeeks.month &&
//                                         p.label === week,
//                                     )?.planned ?? "";

//                                 // Convert "week_20" to 20
//                                 const weekNum = parseInt(
//                                   week.replace(/\D/g, ""),
//                                   10,
//                                 );

//                                 // Find the matching quantity for the given week
//                                 const quantityRecord = boqItem?.quantities?.[
//                                   monthWithWeeks.month
//                                 ]?.find((q) => q.week === weekNum);

//                                 const quantityValue = quantityRecord
//                                   ? quantityRecord.quantity
//                                   : "";

//                                 // Use editedValues or fallback to quantityValue/plannedQty
//                                 const inputValue =
//                                   editedValues[row.id]?.[
//                                     monthWithWeeks.month
//                                   ]?.[week] ??
//                                   quantityValue ??
//                                   plannedQty ??
//                                   "";

//                                 return (
//                                   <td key={`${monthWithWeeks.month}-${week}`}>
//                                     <input
//                                       type="number"
//                                       className="qty-input"
//                                       value={inputValue}
//                                       placeholder="Enter Acutual Qty"
//                                       onChange={(e) =>
//                                         handleInputChange(
//                                           monthWithWeeks.month,
//                                           week,
//                                           e.target.value,
//                                           row.id,
//                                         )
//                                       }
//                                       onKeyDown={(e) =>
//                                         handleKeyPress(
//                                           e,
//                                           monthWithWeeks.month,
//                                           week,
//                                           row.id,
//                                         )
//                                       }
//                                       min={1}
//                                     />
//                                     <div className="planned-qty">
//                                       <span
//                                         className={`planned-dot ${getPlannedDotColor(
//                                           inputValue,
//                                           plannedQty,
//                                         )}`}
//                                       ></span>{" "}
//                                       Planned: {plannedQty}
//                                     </div>
//                                   </td>
//                                 );
//                               });
//                             },
//                           )}
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               ) : (
//                 <div>No BOQ details found.</div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000} // Converted to milliseconds
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default BOQAddQtyForWeek;

import React, { useState, useEffect } from "react";
import "./BOQAddDetails.css";
import axios from "axios";
import API_URL from "../../../src/Config";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { MdFileDownload } from "react-icons/md";

function BOQAddQtyForWeek({ isSidebarExpanded }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [billingFrequency, setBillingFrequency] = useState("weekly");
  const [billingData, setBillingData] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, type = "success") => {
    setSnackbarMessage(message);
    setSeverity(type);
    setSnackbarOpen(true);
  };

  const fetchBillingReport = async (frequency) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/billing_report`, {
        headers: { Authorization: authKey },
        params: {
          billing_frequency: frequency,
          project_id: id,
        },
      });

      console.log("Billing Report Data:", response.data);
      setBillingData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching billing report:", error.message);
      setError(error.message);
      showSnackbar("Failed to fetch billing report", "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBillingReport(billingFrequency);
  }, [billingFrequency]);

  const handleFrequencyChange = (frequency) => {
    setBillingFrequency(frequency);
  };

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/billing_report/export`, {
        headers: { Authorization: authKey },
        params: {
          billing_frequency: billingFrequency,
          project_id: id,
        },
        responseType: "blob",
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      link.setAttribute(
        "download",
        `Billing_Report_${billingFrequency}_${timestamp}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showSnackbar("Report exported successfully", "success");
      setIsExporting(false);
    } catch (error) {
      console.error("Error exporting report:", error.message);
      showSnackbar("Failed to export report", "error");
      setIsExporting(false);
    }
  };

  const handleBack = () => {
    navigate("/amc-projects");
  };

  function formatNumber(number) {
    if (!number) return "0";
    const parts = number.toString().split(".");
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? "." + parts[1] : "";

    let formattedIntegerPart = "";
    let lakhFlag = false;
    let croreFlag = false;
    let croreLakhFlag = false;

    for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
      if (count === 3 && !lakhFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        lakhFlag = true;
      }

      if (count === 2 && lakhFlag && !croreFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        croreFlag = true;
      }

      if (count === 2 && croreFlag && !croreLakhFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        croreLakhFlag = true;
      }

      formattedIntegerPart = integerPart[i] + formattedIntegerPart;
    }

    return formattedIntegerPart + decimalPart;
  }

  const renderMonthlyBreakdown = (serviceReport) => {
    const { breakdown } = serviceReport;

    return breakdown.map((period, index) => (
      <tr key={index}>
        {index === 0 && (
          <>
            <td rowSpan={breakdown.length} className="sticky-col boq-th1">
              {serviceReport.service_code}
            </td>
            <td rowSpan={breakdown.length} className="sticky-col boq-th2">
              {serviceReport.boq_info.description}
            </td>
            <td rowSpan={breakdown.length} className="sticky-col boq-th3">
              {serviceReport.boq_info.uom}
            </td>
            <td rowSpan={breakdown.length} className="sticky-col boq-th4">
              {serviceReport.boq_info.qty}
            </td>
            <td rowSpan={breakdown.length} className="sticky-col boq-th5">
              ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
            </td>
            <td rowSpan={breakdown.length} className="sticky-col boq-th6">
              ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
            </td>
          </>
        )}
        <td>{period.period}</td>
        <td>{period.planned_qty}</td>
        <td>{period.completed_qty}</td>
        <td>{period.variance}</td>
        <td>{period.completion_percentage}%</td>
        <td>₹ {formatNumber(period.amount_without_gst)}</td>
        <td>₹ {formatNumber(period.gst_amount)}</td>
        <td>₹ {formatNumber(period.amount_with_gst)}</td>
      </tr>
    ));
  };

  const renderWeeklyBreakdown = (serviceReport) => {
    const { breakdown } = serviceReport;
    let totalRows = 0;

    // Calculate total rows
    breakdown.forEach((month) => {
      totalRows += month.weeks.length;
    });

    let currentRow = 0;

    return breakdown.map((month, monthIndex) => {
      return month.weeks.map((week, weekIndex) => {
        const isFirstRow = currentRow === 0;
        currentRow++;

        return (
          <tr key={`${monthIndex}-${weekIndex}`}>
            {isFirstRow && (
              <>
                <td rowSpan={totalRows} className="sticky-col boq-th1">
                  {serviceReport.service_code}
                </td>
                <td rowSpan={totalRows} className="sticky-col boq-th2">
                  {serviceReport.boq_info.description}
                </td>
                <td rowSpan={totalRows} className="sticky-col boq-th3">
                  {serviceReport.boq_info.uom}
                </td>
                <td rowSpan={totalRows} className="sticky-col boq-th4">
                  {serviceReport.boq_info.qty}
                </td>
                <td rowSpan={totalRows} className="sticky-col boq-th5">
                  ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
                </td>
                <td rowSpan={totalRows} className="sticky-col boq-th6">
                  ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
                </td>
              </>
            )}
            {weekIndex === 0 && (
              <td rowSpan={month.weeks.length}>{month.month}</td>
            )}
            <td>{week.week}</td>
            <td>{week.planned_qty}</td>
            <td>{week.completed_qty}</td>
            <td>{week.variance}</td>
            <td>{week.completion_percentage}%</td>
            <td>₹ {formatNumber(week.amount_without_gst)}</td>
            <td>₹ {formatNumber(week.gst_amount)}</td>
            <td>₹ {formatNumber(week.amount_with_gst)}</td>
          </tr>
        );
      });
    });
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-edit-form-content">
          <div className="data-edit-form-header">
            <div className="data-edit-form-header-content">
              <div className="data-edit-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBack}
                  />
                </Tooltip>
                Billing Report
              </div>
              <div className="new_billing_ui_header_right">
                <div className="new_billing_ui_radio_group">
                  <label className="new_billing_ui_radio_label">
                    <input
                      type="radio"
                      name="frequency"
                      value="weekly"
                      checked={billingFrequency === "weekly"}
                      onChange={() => handleFrequencyChange("weekly")}
                    />
                    <span>Weekly</span>
                  </label>
                  <label className="new_billing_ui_radio_label">
                    <input
                      type="radio"
                      name="frequency"
                      value="monthly"
                      checked={billingFrequency === "monthly"}
                      onChange={() => handleFrequencyChange("monthly")}
                    />
                    <span>Monthly</span>
                  </label>
                </div>
                <button
                  className="new_billing_ui_export_btn"
                  onClick={handleExport}
                  disabled={isExporting}
                >
                  <MdFileDownload size={20} />
                  {isExporting ? "Exporting..." : "Export"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="header-separator"></div>

        {billingData && (
          <div className="new_billing_ui_project_info">
            <div className="new_billing_ui_info_item">
              <strong>Project:</strong> {billingData.project_info.project_name}
            </div>
            <div className="new_billing_ui_info_item">
              <strong>Duration:</strong>{" "}
              {new Date(
                billingData.project_info.start_date
              ).toLocaleDateString()}{" "}
              to{" "}
              {new Date(
                billingData.project_info.end_date
              ).toLocaleDateString()}
            </div>
            <div className="new_billing_ui_info_item">
              <strong>Service Codes:</strong>{" "}
              {billingData.total_service_codes}
            </div>
          </div>
        )}

        <div className="data-list-body">
          <div className="data-list-scroll-body-boq">
            <div className="data-list-table-boq">
              {loading ? (
                <div className="loader-container">
                  <div className="loader"></div>
                  <div>Loading...</div>
                </div>
              ) : billingData &&
                billingData.service_code_reports.length > 0 ? (
                <table className="excel-table">
                  <thead>
                    <tr>
                      <th
                        rowSpan="2"
                        className="sticky-col sticky-back boq-th1 new_boq_table_th"
                      >
                        Service Code
                      </th>
                      <th
                        rowSpan="2"
                        className="sticky-col sticky-back boq-th2 new_boq_table_th"
                      >
                        Description
                      </th>
                      <th
                        rowSpan="2"
                        className="sticky-col sticky-back boq-th3 new_boq_table_th"
                      >
                        UOM
                      </th>
                      <th
                        rowSpan="2"
                        className="sticky-col sticky-back boq-th4 new_boq_table_th"
                      >
                        Quantity
                      </th>
                      <th
                        rowSpan="2"
                        className="sticky-col sticky-back boq-th5 new_boq_table_th"
                      >
                        Unit Rate
                      </th>
                      <th
                        rowSpan="2"
                        className="sticky-col sticky-back boq-th6 new_boq_table_th"
                      >
                        Total Amount (with GST)
                      </th>
                      {billingFrequency === "weekly" && (
                        <th rowSpan="2" className="new_boq_table_th">
                          Month
                        </th>
                      )}
                      <th rowSpan="2" className="new_boq_table_th">
                        {billingFrequency === "weekly" ? "Week" : "Period"}
                      </th>
                      <th rowSpan="2" className="new_boq_table_th">
                        Planned Qty
                      </th>
                      <th rowSpan="2" className="new_boq_table_th">
                        Completed Qty
                      </th>
                      <th rowSpan="2" className="new_boq_table_th">
                        Variance
                      </th>
                      <th rowSpan="2" className="new_boq_table_th">
                        Completion %
                      </th>
                      <th rowSpan="2" className="new_boq_table_th">
                        Amount (without GST)
                      </th>
                      <th rowSpan="2" className="new_boq_table_th">
                        GST Amount
                      </th>
                      <th rowSpan="2" className="new_boq_table_th">
                        Amount (with GST)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {billingData.service_code_reports.map(
                      (serviceReport, index) => (
                        <React.Fragment key={index}>
                          {billingFrequency === "monthly"
                            ? renderMonthlyBreakdown(serviceReport)
                            : renderWeeklyBreakdown(serviceReport)}
                        </React.Fragment>
                      )
                    )}
                  </tbody>
                </table>
              ) : (
                <div>No billing data found.</div>
              )}
            </div>
          </div>
        </div>

        {billingData && billingData.overall_summary && (
          <div className="new_boq_totals_container">
            <div className="new_boq_totals_row">
              <div className="new_boq_totals_card">
                <div>
                  <div className="new_boq_totals_title">Total Planned Qty</div>
                  <div className="new_boq_totals_value">
                    {billingData.overall_summary.total_planned_qty}
                  </div>
                </div>
                <div>
                  <div className="new_boq_totals_title">
                    Total Completed Qty
                  </div>
                  <div className="new_boq_totals_value">
                    {billingData.overall_summary.total_completed_qty}
                  </div>
                </div>
                <div>
                  <div className="new_boq_totals_title">Completion %</div>
                  <div className="new_boq_totals_value">
                    {billingData.overall_summary.completion_percentage}%
                  </div>
                </div>
              </div>

              <div className="new_boq_totals_card">
                <div>
                  <div className="new_boq_totals_title">
                    Amount (without GST)
                  </div>
                  <div className="new_boq_totals_value">
                    ₹{" "}
                    {formatNumber(
                      billingData.overall_summary.total_amount_without_gst
                    )}
                  </div>
                </div>
              </div>

              <div className="new_boq_totals_card gst">
                <div>
                  <div className="new_boq_totals_title">GST Amount</div>
                  <div className="new_boq_totals_value">
                    ₹{" "}
                    {formatNumber(
                      billingData.overall_summary.total_gst_amount
                    )}
                  </div>
                </div>
              </div>

              <div className="new_boq_totals_card">
                <div>
                  <div className="new_boq_totals_title">
                    Total Amount (with GST)
                  </div>
                  <div className="new_boq_totals_value">
                    ₹{" "}
                    {formatNumber(
                      billingData.overall_summary.total_amount_with_gst
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default BOQAddQtyForWeek;